import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { Theme } from '@astryxdesign/core/theme';
import { padelrTheme } from './theme/padelr';

import MainView from './views/Main'
import SupportView from './views/Support';
import PrivacyView from './views/Privacy';
import ProfileView from './views/Profile';
import InvitationView from './views/Invitation';
import AppLinkView from './views/AppLink';
import FoundationCheckView from './views/FoundationCheck';
import TrackedMatchLiveView from './views/TrackedMatchLive';
import ConsoleView from './views/console/Console';
import CoachListView from './views/coach/CoachList';
import CoachProfileView from './views/coach/CoachProfile';

function ProfileViewRouter() {
  let params = useParams();
  return (
    <ProfileView username={params.username}/>
  )
}

function TrackedMatchLiveViewRouter() {
  let params = useParams();
  // Keyed by the token so that following a second link in the same tab starts
  // from nothing rather than from the first match's state.
  return (
    <TrackedMatchLiveView key={params.token} token={params.token}/>
  )
}

function CoachProfileViewRouter() {
  let params = useParams();
  return (
    <CoachProfileView key={params.username} username={params.username}/>
  )
}

function InvitationViewRouter() {
  return (
    <InvitationView />
  )
}

function App() {

  // The built theme object, not a runtime defineTheme() call: its CSS is
  // imported by index.css and is present on first paint. A runtime theme
  // injects its tokens after hydration instead, which on this site would mean
  // a visitor following an invitation link seeing one unthemed frame before
  // anything else - and that link is the first thing a new player ever opens.
  // The source is theme/padelr.theme.mjs; theme/padelr.js and padelr.css are
  // generated from it by `npm run theme:build` and committed.
  //
  // mode is left at its default of 'system', so the site follows the reader's
  // OS preference rather than picking for them.
  return (
    <Theme theme={padelrTheme}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<MainView />} />
            <Route path='/profile/:username' element={<ProfileViewRouter />} />
            <Route path='/invitation/:payload' element={<InvitationViewRouter />} />
            {/* Only reached when nothing claimed the link - on a phone with the
                app installed, iOS and Android open the screen directly. */}
            <Route path='/app/*' element={<AppLinkView />} />
            {/* A live link to a tracked match. Deliberately not claimed by the
                apps' universal links: it has to open in a browser, for the
                people it is sent to, whether or not they have the app. */}
            <Route path='/match/:token' element={<TrackedMatchLiveViewRouter />} />
            {/* The coaches and the page a coach shares (hidden-beacon-3).
                Not claimed by the apps either, for the same reason as /match:
                it is read in a browser by whoever the link was sent to.
                Booking is handed to the app from the page itself. */}
            <Route path='/coach' element={<CoachListView />} />
            <Route path='/coach/:username' element={<CoachProfileViewRouter />} />
            {/* The club admins' console. Logged in by scanning its QR code
                from the app, never by a password typed here. */}
            <Route path='/console' element={<ConsoleView />} />
            <Route path='/support' element={<SupportView />} />
            <Route path='/privacy' element={<PrivacyView />} />
            {/* The cascade-layer smoke test. Kept in the shipped build so the
                question can be asked of a real deployment, not only of a dev
                server - see views/FoundationCheck.js. */}
            <Route path='/_foundation' element={<FoundationCheckView />} />
          </Routes>
        </BrowserRouter>
      </div>
    </Theme>
  )

}

export default App;
